import type { EventWithDistributionList } from 'models';
import { Avatar, Col, Row, Text } from 'ui';
import { images } from 'common/utils';
import { useGetMediaSourceVariant } from 'features/media';
import { EventInviteesListRow } from '../../../../components';

type P = {
  distribution: EventWithDistributionList;
};

const EventDistributionList = ({ distribution }: P) => {
  const getMediaSource = useGetMediaSourceVariant();

  return (
    <EventInviteesListRow key={distribution.communityId}>
      <Col>
        <Avatar
          fallbackPhoto={images.default.communityProfilePhoto}
          src={getMediaSource({ id: distribution.communityId, type: 'community_profile_photo' })}
        />
      </Col>
      <Col flex="1 1 0">
        <Row>
          <Col span={24}>
            <Text type="title" weight="medium">
              {distribution.communityName}
            </Text>
          </Col>
          <Col span={24}>
            <Text size="small">Attendees</Text>
          </Col>
        </Row>
      </Col>
    </EventInviteesListRow>
  );
};

export default EventDistributionList;
